import { createAuthenticator } from 'redux-simple-auth'

const validateToken = ({ token }) =>
  token ? Promise.resolve({ token }) : Promise.reject('Token is empty')

export default createAuthenticator({
  name: 'unified',
  restore: validateToken,
  authenticate: token => validateToken({ token })
})



// WEBPACK FOOTER //
// ./src/authenticators/unified.js